import React from 'react';
import { ParameterType, Type } from '../apiref/apireftypes';
import { ApiRef } from '../fasades/apiref';

export function createGenerateResponse() : ParameterType
{
    const messageType = ApiRef.getType("Message");
    const usageType = ApiRef.getType("Usage");
    const desc = (<>
        <p>This is the standard (non-streaming) response format returned by the Generate Response endpoint. It contains the generated message along with usage statistics.</p>            
        </>);

    return {
        id          : "GenerateResponse",
        name        : "GenerateResponse",
        description : desc,
        type        : Type.Object,
        parameters  : [
            {
                "name"        : "id",
                "type"        : "string",
                "description" : <p>The conversation ID that uniquely identifies this conversation session.</p>,
                "optional"    : false
            },
            {
                "name"        : "message",
                "type"        : "Message",
                "description" : <><p>The generated message from the assistant. Contains the role (always "assistant") and the content (the generated text).</p>{ messageType.description }</>,
                "optional"    : false
            },
            {
                "name"        : "usage",
                "type"        : "Usage",
                "description" : usageType.description,
                "optional"    : false
            }
        ]
    };
}

